import { Route, Routes } from 'react-router-dom'
import { ApplicationsRouter } from 'pages/settings/pages/developer/pages/applications/route/applicationsRouter'
import { AccessTokensRouter } from 'pages/settings/pages/developer/pages/accessTokens/route/accessTokensRouter'
import { AuthorizedAppsRouter } from 'pages/settings/pages/developer/pages/authorizedApps'
import { DeveloperRoutes } from 'pages/settings/pages/developer/route/type'

export const DeveloperRouter = () => {
  return (
    <Routes>
      <Route path={`/${DeveloperRoutes.applications}`} element={<ApplicationsRouter />} />
      <Route path={`/${DeveloperRoutes.accessTokens}`} element={<AccessTokensRouter />} />
      <Route path={`/${DeveloperRoutes.authorizedApps}`} element={<AuthorizedAppsRouter />} />
    </Routes>
  )
}
